import SingleSiteTrend from "./SingleSiteTrend";
import Authorization from "../../../../../generics/authorization";
import { getCookie } from "../../../../../serviceWorker";
import convergedPredictiveFilterDashlets from "../../../convergedPredictiveFilterDashlets";

const isUIConvergence = getCookie("cl-analytics");

const filterDashlets = isUIConvergence
    ? convergedPredictiveFilterDashlets
    : {};

const pageProps = {
    ...filterDashlets,
    dashlets: [
        {
            component: SingleSiteTrend,
            name: "ad-ss-trend-view",
            layout: { x: 0, y: 0, w: 12, h: 66 }
        }
    ]
  };

const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
